// extracted by mini-css-extract-plugin
export default {"image":"uZ-z","loaded":"vZ-z"};